import React from 'react';
import { Button } from 'primereact/button';
import { router } from '@inertiajs/react';
import Language from '@Components/Language';

export function ActionButtonTemplate({
  edit_route,
  label = Language.get('Open'),
  type = 'edit'
}: {
  edit_route: string;
  label?: string;
  type?: 'edit' | 'view' | 'create';
}) {

  const iconMap: Record<string, string> = {
    edit: 'pi-pencil',
    view: 'pi-eye',
    create: 'pi-file-edit',
  };
  return (
    <Button
      tooltipOptions={{ showDelay: 1000, hideDelay: 300, position: 'bottom' }}
      text
      tooltip={Language.get(label)}
      data-dusk="open-button"
      // label={label}
      onClick={() => {
        if (!edit_route) return;
        router.get(edit_route);
        setTimeout(() => router.reload({ only: ['flash'], replace: true }), 0);
      }}
      icon={`pi ${iconMap[type] || 'pi-pencil'}`}
      pt={{
        icon: { className: 'text-600 text-ls' },
      }}
    />
  );
}
